import React from 'react';
import { Link } from 'react-router-dom';
import useSeo from '../hooks/useSeo';
import './Pages.css';

function UnlimitedSupport() {
  useSeo(
    'Unlimited Support | Rev-Tech Services',
    'Rev-Tech unlimited support delivers fast helpdesk response, remote troubleshooting, and on-site assistance for your team.',
    {
      canonical: 'https://www.rev-technology.com/services/unlimited-support'
    }
  );

  return (
    <div className="page">
      <h1>Unlimited Support</h1>
      <section className="content-section">
        <p>
          Our unlimited support service gives your team access to fast, reliable help when they need it most. We provide responsive
          remote support and on-site assistance to address issues quickly and keep your business moving.
        </p>
      </section>

      <section className="content-section">
        <h2>What&apos;s Included</h2>
        <ul className="values-list">
          <li><strong>Helpdesk support:</strong> Fast response for end-user questions and technical issues.</li>
          <li><strong>Remote troubleshooting:</strong> Quick resolution for desktop and application problems.</li>
          <li><strong>On-site support:</strong> As-needed on-site visits for complex or urgent issues.</li>
          <li><strong>Unlimited access:</strong> Predictable coverage that eliminates surprise support costs.</li>
        </ul>
      </section>

      <section className="content-section">
        <h2>Why it matters</h2>
        <p>
          Unlimited support reduces frustration and downtime by giving your staff the help they need when they need it.
          Rev-Tech becomes your trusted IT partner, not just a temporary fix.
        </p>
      </section>

      <Link to="/services" className="cta-button">Back to Services</Link>
    </div>
  );
}

export default UnlimitedSupport;
